import { BreakpointObserver } from '@angular/cdk/layout';
import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DiscoverFacade } from '@zero/discover/domain';
import { DiscoverArticleComponent, DiscoverCardType } from '@zero/discover/feature-discover/web';
import { environment } from 'environments/environment';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'stocks-discover-news',
  standalone: true,
  imports: [AsyncPipe, DiscoverArticleComponent, TranslocoPipe],
  templateUrl: './discover-news.component.html',
  styleUrl: './discover-news.component.scss',
})
export class DiscoverNewsComponent implements OnInit {
  @ViewChild('modal') public modal?: TemplateRef<HTMLElement>;

  public readonly facade = inject(DiscoverFacade);
  readonly #breakpointObserver = inject(BreakpointObserver);
  readonly #ngbModal = inject(NgbModal);
  readonly #destroyRef = inject(DestroyRef);
  public readonly imageBase = environment.assetshost;
  public readonly DiscoverCardType = DiscoverCardType;

  public slideRange = [];

  ngOnInit(): void {
    this.facade.loadDiscoverOverview();

    combineLatest([this.#breakpointObserver.observe('(max-width: 767px)'), this.facade.todayTeaser$])
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(([state, teasers]) => (this.slideRange = [0, (state.matches ? 1 : Math.min(teasers.length, 4)) - 1]));
  }

  public openDetails(id: string) {
    this.facade.loadDiscoverTodayDetails(id);
    this.#ngbModal.open(this.modal, { size: 'xl', centered: true });
  }

  public prev() {
    this.slideRange[0] -= 1;
    this.slideRange[1] -= 1;
  }

  public next() {
    this.slideRange[0] += 1;
    this.slideRange[1] += 1;
  }
}
